import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

import { AuthService, AppSettingsService, ClaimsService, MenuService, StorageService } from './core/services';
import { LastUpdateBroadcaster } from './core/broadcasts/last-updated-broadcaster';
import { consts } from "./shared/consts";
import { LogoutService } from './core/services/logout.service';
import { Observable } from 'rxjs/Observable';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit{

    public links: Array<any> = [];
    isAuthenticated: boolean = true;
    isNavBarFolded: boolean = false;
    isAccountBarExpanded: boolean = false;
    userName: string = '';
    activeLink: string;
    lastUpdate: Date = null;
    private sub: any;

    constructor(
        private router: Router,
        private authService: AuthService,
        private appSettingsService: AppSettingsService,
        private menuService: MenuService,
        private claimsService: ClaimsService,
        private lastUpdateBroadcaster: LastUpdateBroadcaster,
        private storageService: StorageService,
        private logoutService: LogoutService) { }

    ngOnInit(){
        this.router.events.subscribe(event => {
            if (this.authService.isAuthorized()) {
               
                // check if the connection has not expired 
                if (this.logoutService.getTimer()) this.logoutService.unsubscribeTimer();
                this.logoutService.setTimer( Observable.interval(1000 * 60).subscribe(x => {
                    if (this.authService.isAuthorized() && this.authService.isBearerTokenExpired()) {
                         this.logoutService.connectionTimeOut()
                    }
                }));

                this.userName = this.getUserName();
                this.links = this.menuService.getMenuItems(this.claimsService.getUserTypeId());
                if (event instanceof NavigationStart) {
                    if (this.sub) {
                        this.sub.unsubscribe();
                        this.sub = null;
                    }
                    this.lastUpdate = null;
                }

                if (event instanceof NavigationEnd) {
                    this.activeLink = event.url;
                    if (event.url === this.appSettingsService.AdminDashboardPath || event.url === this.appSettingsService.PublisherDashboardPath)
                        this.sub = this.lastUpdateBroadcaster.event.subscribe(() => this.lastUpdate = new Date());
                    window.scroll(0, 0);
                }
                this.isAuthenticated = true;
                this.isAccountBarExpanded = false;
            } else { this.isAuthenticated = false; }
        });
        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .pairwise().subscribe((e) => {
                let previousUrl = e[0].url;
                let nextUrl = e[1].url;
                if (previousUrl && nextUrl) {
                    if (previousUrl.indexOf(this.appSettingsService.CampaignDetails) > -1 && nextUrl.indexOf(this.appSettingsService.Campaigns) > -1) {
                        return;
                    } else {
                        if (nextUrl.indexOf(this.appSettingsService.CampaignDetails) > -1 && previousUrl.indexOf(this.appSettingsService.Campaigns) > -1)
                            return;
                        else {
                            this.storageService.remove(consts.CampaignFilterStorageKey);
                            this.storageService.remove(consts.PublisherIdsFilterStorageKey);
                            this.storageService.remove(consts.MediationFilterStorageKey);
                            this.storageService.remove(consts.ProviderIdsFilterStorageKey);
                        }
                    }
                }
            });
    }

    public onNavbarLinkClick(event: Event) {
        let route = (<any>event).route;
        if ((route || '') === '') { return; }

        this.router.navigate([route]);
    };

    public onLogout(event: Event) {
        this.logoutService.logout();
    }

    public onToggleNavBarClick(event: Event) {
        this.isNavBarFolded = !this.isNavBarFolded;
    }

    public onToggleAccountBarClick(event: Event) {
        this.isAccountBarExpanded = !this.isAccountBarExpanded;
    }

    private getUserName(): string {
        let firstName = this.claimsService.getFirstName();
        if (!firstName)
            firstName = '';
        let lastName = this.claimsService.getLastName();
        if (!lastName)
            lastName = '';
        return firstName + ' ' + lastName;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts